/* eslint-disable jsx-a11y/anchor-is-valid */
import { GridContent, PageContainer } from "@ant-design/pro-components";
import {
  useCallback,
  useEffect,
  // useMemo,
  useRef,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import {
  Card,
  // Carousel,
  Col,
  // Empty,
  Flex,
  Image,
  message,
  // Modal,
  // notification,
  // Result,
  Row,
  Spin,
  // Tag,
  // Tooltip,
  // List
} from "antd";
import { getSocket2 } from "../service/socket.service";
import Meta from "antd/es/card/Meta";
import axios from "axios";
// import { Footer, Header } from "antd/es/layout/layout";
import {
  LoadingOutlined,
  // MoreOutlined
} from "@ant-design/icons";
import { numberFormat } from "../utility/util";
// import dayjs from "dayjs";
// const currentDate = dayjs().format("YYYY-MM-DD");
const privateKey =
  "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
const BASE = privateKey.length;
const SECRET = 987654321;

const FBLiveProductPreviewsPage = () => {
  const authorization_token = btoa(`chgold_admin:chgold_password`);
  const new_token = btoa(
    `d77d00700bc79392f68fa1b7a7705af65220710e20a45722511f6dc0c2683917:${authorization_token}`
  );

  const { id } = useParams();
  const hasInitialized = useRef(false);
  const [isContentLoaded, setIsContentLoaded] = useState(false);
  const [dataList, setDataList] = useState([]);
  // const [api, contextHolder] = notification.useNotification();
  // const [fileList, setFileList] = useState([]);
  // const [ImgModalOpen, isImgModalOpen] = useState(false);
  // const [eventValid, isEventValid] = useState(false);

  // // Wrap notification function
  // const openNotification = useCallback(
  //   (title, description) => {
  //     api.open({
  //       message: title,
  //       description,
  //       placement: "topRight",
  //       showProgress: true,
  //       pauseOnHover: true,
  //     });
  //   },
  //   [api]
  // );

  function decodeBase62(str) {
    return str
      .split("")
      .reduce((acc, c) => acc * BASE + privateKey.indexOf(c), 0);
  }

  const decodeId = useCallback((token) => {
    const num = decodeBase62(token.replace(/^0+/, "")); // remove leading zeros
    const id = num ^ SECRET;
    return id;
  }, []);

  // const decryptParams = decodeId(id);

  const fetchProductPreviews = useCallback(async () => {
    try {
      const { data: responseData } = await axios.get(
        `${
          process.env.REACT_APP_ENVIRONMENT === "PRODUCTION"
            ? process.env.REACT_APP_API_BASE_URL
            : process.env.REACT_APP_API_STAGING_BASE_URL
        }/fbLive/getProductPreviews`,
        {
          params: {
            fbLiveId: id,
            pageSize: 9999,
          },
          headers: {
            Authorization: `Basic ${new_token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!responseData.status) {
        message.error(responseData.message);
        return responseData.status;
      }

      // const liveData = responseData.liveResult;
      // const productList = responseData.data;

      // // if (
      // //   currentDate >= liveData.startDate &&
      // //   currentDate <= liveData.endDate
      // // ) {
      // //   isEventValid(true);
      // // }

      // if (productList.length > 0) {
      //   for (const pl of productList) {
      //     let tmpCustomerNameList = [];

      //     if (pl.customerNameList) {
      //       try {
      //         tmpCustomerNameList = JSON.parse(pl.customerNameList);
      //       } catch (error) {
      //         tmpCustomerNameList = [];
      //       }
      //     }

      //     pl.customerNameList = tmpCustomerNameList;
      //   }
      // }

      // setLiveData(liveData);

      setDataList(responseData.data.rows);
      return responseData.status;
    } catch (error) {
      console.log("Error: ", error);
    }
  }, [id, new_token]);

  const componentInit = useCallback(async () => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    if (!id) {
      return;
    }

    try {
      const result = await fetchProductPreviews();
      if (!result) {
        return;
      }

      setIsContentLoaded(true);
    } catch (error) {
      console.log("Initialization error:", error);
      message.error("Page failed to initialize");
    }
  }, [id, fetchProductPreviews]);

  useEffect(() => {
    componentInit();
  }, [componentInit, dataList, decodeId, id]);

  useEffect(() => {
    const socket = getSocket2();

    // socket.on("productUpdate", (data) => {
    //   if (data?.data) {
    //     const updatedData = data.data;
    //     setDataList((prev) => {
    //       const index = prev.findIndex((item) => item.id === updatedData.id);

    //       if (index !== -1) {
    //         const updatedList = [...prev];
    //         updatedList[index] = {
    //           ...updatedList[index],
    //           ...updatedData,
    //           image: updatedData.image ?? [],
    //         };
    //         return updatedList;
    //       } else {
    //         return [...prev, updatedData];
    //       }
    //     });
    //   }
    // });

    // socket.on("productChanged", (data) => {
    //   if (data?.data?.length > 0) {
    //     const tmpData = dataList;
    //     const merged = tmpData.map((item1) => {
    //       const match = data.data.find((item2) => item2.id === item1.id);
    //       return match
    //         ? {
    //             ...item1,
    //             name: match.name,
    //             label: match.label,
    //             liveItemCode: match.liveItemCode,
    //             designCode: match.designCode,
    //             // quantity: match.quantity,
    //             labourFee: match.labourFee,
    //             price: match.price,
    //             remark: match.remark,
    //             fbLiveProductVariations: match.fbLiveProductVariations,
    //           }
    //         : item1;
    //     });

    //     setDataList(merged);
    //   }

    //   // const title = "📦 New order";
    //   // console.log("New ORDER");
    //   // openNotification(title, data);
    // });

    socket.on("productPreviewUpdate", async () => {
      await fetchProductPreviews();
      // if (data?.data) {
      //   const updatedData = data.data;
      //   if (updatedData.length > 0) {
      //     for (const ud of updatedData) {
      //       let tmpCustomerNameList = [];

      //       if (ud.customerNameList) {
      //         try {
      //           tmpCustomerNameList = JSON.parse(ud.customerNameList);
      //         } catch (error) {
      //           tmpCustomerNameList = [];
      //         }
      //       }

      //       ud.customerNameList = tmpCustomerNameList;
      //     }
      //   }
      //   setDataList(updatedData);
      // }
      // if (data?.liveData) {
      //   setLiveData(data.liveData);
      //   if (
      //     currentDate < liveData.startDate &&
      //     currentDate > liveData.endDate
      //   ) {
      //     isEventValid(true);
      //   }
      // }
    });

    return () => {
      // socket.off("productUpdate");
      socket.off("productPreviewUpdate");
      // socket.off("productChanged");
    };
  });

  // const viewImgModalOpen = (imgArr) => {
  //   if (imgArr) {
  //     setFileList(imgArr);
  //     isImgModalOpen(true);
  //   }
  // };

  // const viewImgModal = useMemo(
  //   () => (
  //     <Modal
  //       title="View Product Image"
  //       open={ImgModalOpen}
  //       okButtonProps={{ style: { display: "none" } }}
  //       onCancel={() => isImgModalOpen(false)}
  //     >
  //       <div
  //         style={{
  //           display: "grid",
  //           gap: "16px",
  //           gridTemplateColumns:
  //             fileList?.length < 2 ? "repeat(1, 1fr)" : "repeat(2, 1fr)",
  //           alignItems: "center",
  //         }}
  //       >
  //         {fileList ? (
  //           fileList.map((i) => (
  //             <Image
  //               src={i.fullImagePath}
  //               onError={(e) => {
  //                 e.target.onerror = null; // prevent infinite loop
  //                 e.target.src = "/noimage.jpg";
  //               }}
  //             />
  //           ))
  //         ) : (
  //           <Empty description="No data available" />
  //         )}
  //       </div>
  //     </Modal>
  //   ),
  //   [ImgModalOpen, fileList]
  // );

  return (
    <PageContainer className="productListingPageContainer">
      {/* <Header className="productListingHeader">
        <Image
          src="/chgd-logo-white.png"
          style={{ maxWidth: 300 }}
          preview={false}
        ></Image>
      </Header> */}
      <GridContent>
        {/* {eventValid ? ( */}
        <>
          {isContentLoaded && dataList.length > 0 ? (
            <div className="productListingContainer">
              <div className="tableTitle specialFontFamily">
                Product Previews
              </div>
              {/* <div className="specialFontFamily" style={{ marginBlockEnd: 15 }}>
                {dataList.length} Products
              </div> */}
              <Row gutter={[18, 18]}>
                {dataList.map((item) => (
                  <Col
                    key={item.id}
                    xs={24}
                    sm={12}
                    md={8}
                    lg={8}
                    xl={6}
                    style={{ width: "100%", margin: 0 }}
                  >
                    <Card
                      draggable
                      hoverable
                      // onClick={() => viewImgModalOpen(item.fbProductImage)}
                      cover={
                        <>
                          {item?.fbLiveProduct?.image !== `[]` &&
                          item.fbLiveProduct.fbProductImage ? (
                            <div>
                              {/* <Carousel
                                  autoplay
                                  style={{
                                    maxHeight: 310,
                                    overflow: "hidden",
                                    borderRadius: "8px 8px 0px 0px",
                                  }}
                                > */}
                              {/* {item.fbLiveProduct.fbProductImage.map((img, idx) => ( */}
                              <Image
                                // onClick={() => viewImgModalOpen(item.fbLiveProduct.fbProductImage)}
                                key={item.id}
                                alt={item.name}
                                src={
                                  item?.fbLiveProduct?.fbProductImage[0]
                                    ?.fullImagePath || "/noimage.jpg"
                                }
                                fallback="/noimage.jpg"
                                preview={{
                                  src:
                                    item?.fbLiveProduct?.fbProductImage[0]
                                      ?.fullImagePath || "/noimage.jpg",
                                  fallback: "/noimage.jpg",
                                }}
                                width={"100%"}
                                className="imageCont"
                                style={{
                                  // maxHeight: 310,
                                  width: "100%",
                                  display: "block",
                                  objectFit: "cover",
                                }}
                              />
                              {/* ))} */}
                              {/* </Carousel> */}
                            </div>
                          ) : (
                            <Image
                              width={"100%"}
                              alt={item.name}
                              src="/noimage.jpg"
                              style={{
                                // maxHeight: 310,
                                width: "100%",
                                display: "block",
                                objectFit: "cover",
                              }}
                            />
                          )}
                        </>
                      }
                    >
                      <Meta
                        title={item.fbLiveProduct.name}
                        className="productDesc"
                        description={
                          <>
                            <Flex
                              style={{
                                flexDirection: "column",
                                color: "rgba(0,0,0,0.88)",
                              }}
                              gap={"small"}
                            >
                              {/* <div
                                    style={{
                                      color: "#333333ff",
                                    }}
                                  >
                                    RM{Number(item.price).toFixed(2)}
                                  </div> */}
                              <div
                                style={{
                                  textAlign: "-webkit-center",
                                  fontSize: "medium",
                                }}
                              >
                                <p>
                                  Design Code: {item.designCode}
                                  <br />
                                  Live Item Code: {item.liveItemCode}
                                  <br />
                                  Gram: {numberFormat(item.gram)}
                                  <br />
                                  {/* Price per Gram: {numberFormat(item.pricePerGram)}
                                    <br /> */}
                                  Total: RM{numberFormat(item.total)} +/-
                                  <br />
                                  Labour Fee: RM{numberFormat(item.labourFee)}
                                  <br />
                                  Quantity:{" "}
                                  {
                                    item.fbLiveProduct.fbLiveProductVariations
                                      .length
                                  }{" "}
                                  pcs
                                </p>
                              </div>
                            </Flex>
                          </>
                        }
                      />
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          ) : (
            <>
              <div className="home-spinner-container">
                <Spin
                  indicator={
                    <LoadingOutlined spin style={{ fontSize: "2rem" }} />
                  }
                />
              </div>
            </>
          )}
        </>
        {/* ) : (
          <>
            {" "}
            <div className="productListingContainer">
              <Result
                style={{ marginInline: "auto" }}
                status="404"
                title="Event Unavailable"
              />
            </div>
          </>
        )} */}

        {/* <>{viewImgModal}</> */}
      </GridContent>
      {/* NOTIFICATION */}
      {/* {contextHolder} */}
      {/* <Footer className="productListingFooter">
        <span className="specialFontFamily">
          Chiang Heng Gold & Diamond Sdn Bhd (973341-U). All Rights Reserved.
        </span>
      </Footer> */}
    </PageContainer>
  );
};
export default FBLiveProductPreviewsPage;
